import { useEffect } from 'react'

export const SPORT_IMAGE_LEAVE_MESSAGE = '선택한 운동시설 이미지는 저장 전에 이동하면 사라집니다. 이동하시겠습니까?'

export const hasPendingSportImages = (params = {}, uploadFiles = []) => {
    return params.mainImage instanceof File || uploadFiles.some((file) => file instanceof File)
}

// 브라우저 보안상 file input 값은 복구할 수 없어서, 새로고침/탭 닫기 직전에만 기본 경고를 띄운다.
export const usePendingSportImageUnloadGuard = (enabled) => {
    useEffect(() => {
        if (typeof window === 'undefined' || !enabled) {
            return undefined
        }

        const handleBeforeUnload = (event) => {
            event.preventDefault()
            event.returnValue = ''
            return ''
        }

        window.addEventListener('beforeunload', handleBeforeUnload)

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
        }
    }, [enabled])
}
